/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Reelplicate API
 * OpenAPI spec version: 1.0
 */

/**
 * The AI image model flows use unless a node picks one.
 */
export type ImageModel = (typeof ImageModel)[keyof typeof ImageModel];

export const ImageModel = {
  GPT_IMAGE: 'GPT_IMAGE',
  NANO_BANANA: 'NANO_BANANA',
} as const;
